import get from 'lodash/get'
import set from 'lodash/set'

export default function (geojson) {
  const crs = get(geojson, 'crs.properties.name', '')
  if (crs === 'urn:ogc:def:crs:EPSG::4283') {
    console.log('Detected EPSG::4283, converting to EPSG::4283 (Both Lat/Lng styles.)')
    set(geojson, 'crs.properties.name', 'urn:ogc:def:crs:EPSG::4326')
  }
  return geojson
}
